import { TCloneMonthlyDiscountPolicy, TWritePolicyDocument } from '@src/modules'

import { request } from './config'

export const getMonthlyDiscountConfig = (effectiveFrom: number | undefined, token: string) =>
  request(
    {
      url: 'admin/monthly-discount/config',
      method: 'GET',
      params: effectiveFrom != null ? { effectiveFrom } : undefined,
    },
    { token },
  )

export const putMonthlyDiscountConfig = (body: TWritePolicyDocument, token: string) =>
  request({ url: 'admin/monthly-discount/config', method: 'PUT', data: body }, { token })

export const getMonthlyDiscountVersions = (token: string) =>
  request({ url: 'admin/monthly-discount/versions', method: 'GET' }, { token })

export const cloneMonthlyDiscountConfig = (body: TCloneMonthlyDiscountPolicy, token: string) =>
  request({ url: 'admin/monthly-discount/config/clone', method: 'POST', data: body }, { token })

export const validateMonthlyDiscountConfig = (effectiveFrom: number, token: string) =>
  request(
    { url: `admin/monthly-discount/config/${effectiveFrom}/validate`, method: 'POST' },
    { token },
  )

export const publishMonthlyDiscountConfig = (effectiveFrom: number, token: string) =>
  request(
    { url: `admin/monthly-discount/config/${effectiveFrom}/publish`, method: 'POST' },
    { token },
  )

export const getDealerMonthlyDiscount = (
  userId: number,
  year: number,
  month: number,
  token: string,
) =>
  request(
    { url: `admin/monthly-discount/dealers/${userId}`, method: 'GET', params: { year, month } },
    { token },
  )
